import { render } from "./ParamStatusMatricula.vue?vue&type=template&id=14e03a0e"
import script from "./ParamStatusMatricula.vue?vue&type=script&lang=js"
export * from "./ParamStatusMatricula.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__